export type TelegramActivationPhase = "waiting" | "checking" | "code" | "activating" | "error" | "authenticated";

export function telegramActivationFailure(failure: unknown, enteringCode = false) {
  const error = failure as {
    response?: { status?: number; data?: { message?: string; error?: string } };
    message?: string;
  };
  const status = error?.response?.status;
  const actionKey = status === 400 ? "activationErrors.identity" : status === 401 ? "activationErrors.account" : status === 403 ? "activationErrors.access" : "";
  const message =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    "Unable to connect. Please try again.";

  const isSaleNotFound = !actionKey && /^(?:sale|task) not found(?: or completed)?\.?$/i.test(message.trim());
  const activationMissing = status === 404;
  const quietNotFound = activationMissing && (!enteringCode || isSaleNotFound);

  return {
    phase: enteringCode || activationMissing ? ("code" as const) : ("error" as const),
    message: quietNotFound ? "" : message,
    actionKey,
    saleUnavailable: false,
  };
}
